export default __webpack_public_path__ + "static/media/sanathan-textiles-sees-punjab.eb838ad6.png";